import { FOR_YOU_CHATS_QUERY_KEY } from '@renderer/stores/conversation-query-keys'

export interface ForYouChatsScope {
  audioNoteId?: string | null
  audioSessionId?: string | null
}

/**
 * Identifies the feed a set of For You rows came from, which is what linger state is held
 * against. A meeting's query key flips from its session to its saved note the moment the
 * note lands, so the key here sticks to the id the meeting started with — a row archived
 * a second earlier still belongs to the same feed.
 */
export function forYouFeedKey(scope?: ForYouChatsScope): string {
  if (!scope) return FOR_YOU_CHATS_QUERY_KEY
  return `${FOR_YOU_CHATS_QUERY_KEY}:${scope.audioSessionId ?? scope.audioNoteId ?? ''}`
}
